/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResponse,
  ExternalReferral,
  ExternalReferralResponse,
} from '../models';
import {
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ExternalReferralFromJSON,
    ExternalReferralToJSON,
    ExternalReferralResponseFromJSON,
    ExternalReferralResponseToJSON,
} from '../models';

export interface AssignPatientToExternalReferralRequest {
    referralId: string;
    patientId: string;
}

export interface GetExternalReferralsByStatusRequest {
    status: GetExternalReferralsByStatusStatusEnum;
}

export interface SubmitExternalReferralRequest {
    patientFirstName: string;
    patientLastName: string;
    patientEmail: string;
    referralContext: string;
    submitterEmail: string;
    patientPhone?: string;
    patientOhip?: string;
    attachmentsMetadata?: string;
    file0?: Blob;
    file1?: Blob;
    file2?: Blob;
    file3?: Blob;
    file4?: Blob;
}

export interface UpdateExternalReferralRequest {
    referralId: string;
    externalReferral: ExternalReferral;
}

/**
 * 
 */
export class ReferralsApi extends runtime.BaseAPI {

    /**
     * Assign a patient to an external referral (Roles: physician, admin)
     */
    async assignPatientToExternalReferralRaw(requestParameters: AssignPatientToExternalReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalReferral>> {
        if (requestParameters.referralId === null || requestParameters.referralId === undefined) {
            throw new runtime.RequiredError('referralId','Required parameter requestParameters.referralId was null or undefined when calling assignPatientToExternalReferral.');
        }

        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling assignPatientToExternalReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/referrals/external/{referralId}/assign/{patientId}`.replace(`{${"referralId"}}`, encodeURIComponent(String(requestParameters.referralId))).replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalReferralFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    assignPatientToExternalReferralRequestOptionsRaw(requestParameters: AssignPatientToExternalReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.referralId === null || requestParameters.referralId === undefined) {
            throw new runtime.RequiredError('referralId','Required parameter requestParameters.referralId was null or undefined when calling assignPatientToExternalReferral.');
        }

        if (requestParameters.patientId === null || requestParameters.patientId === undefined) {
            throw new runtime.RequiredError('patientId','Required parameter requestParameters.patientId was null or undefined when calling assignPatientToExternalReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/referrals/external/{referralId}/assign/{patientId}`.replace(`{${"referralId"}}`, encodeURIComponent(String(requestParameters.referralId))).replace(`{${"patientId"}}`, encodeURIComponent(String(requestParameters.patientId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Assign a patient to an external referral (Roles: physician, admin)
     */
    async assignPatientToExternalReferral(requestParameters: AssignPatientToExternalReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalReferral> {
        const response = await this.assignPatientToExternalReferralRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets external referrals by status (Roles: physician, admin)
     */
    async getExternalReferralsByStatusRaw(requestParameters: GetExternalReferralsByStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ExternalReferral>>> {
        if (requestParameters.status === null || requestParameters.status === undefined) {
            throw new runtime.RequiredError('status','Required parameter requestParameters.status was null or undefined when calling getExternalReferralsByStatus.');
        }

        const queryParameters: any = {};

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/referrals/external/status`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ExternalReferralFromJSON));
    }

    /**
        Request Config Getter
     */
    getExternalReferralsByStatusRequestOptionsRaw(requestParameters: GetExternalReferralsByStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.status === null || requestParameters.status === undefined) {
            throw new runtime.RequiredError('status','Required parameter requestParameters.status was null or undefined when calling getExternalReferralsByStatus.');
        }

        const queryParameters: any = {};

        if (requestParameters.status !== undefined) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/referrals/external/status`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets external referrals by status (Roles: physician, admin)
     */
    async getExternalReferralsByStatus(requestParameters: GetExternalReferralsByStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ExternalReferral>> {
        const response = await this.getExternalReferralsByStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit an external referral with attachments (Public)
     */
    async submitExternalReferralRaw(requestParameters: SubmitExternalReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalReferralResponse>> {
        if (requestParameters.patientFirstName === null || requestParameters.patientFirstName === undefined) {
            throw new runtime.RequiredError('patient_first_name','Required parameter requestParameters.patientFirstName was null or undefined when calling submitExternalReferral.');
        }

        if (requestParameters.patientLastName === null || requestParameters.patientLastName === undefined) {
            throw new runtime.RequiredError('patient_last_name','Required parameter requestParameters.patientLastName was null or undefined when calling submitExternalReferral.');
        }

        if (requestParameters.patientEmail === null || requestParameters.patientEmail === undefined) {
            throw new runtime.RequiredError('patient_email','Required parameter requestParameters.patientEmail was null or undefined when calling submitExternalReferral.');
        }

        if (requestParameters.referralContext === null || requestParameters.referralContext === undefined) {
            throw new runtime.RequiredError('referral_context','Required parameter requestParameters.referralContext was null or undefined when calling submitExternalReferral.');
        }

        if (requestParameters.submitterEmail === null || requestParameters.submitterEmail === undefined) {
            throw new runtime.RequiredError('submitter_email','Required parameter requestParameters.submitterEmail was null or undefined when calling submitExternalReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.patientFirstName !== undefined) {
            formParams.append('patient_first_name', requestParameters.patientFirstName as any);
        }

        if (requestParameters.patientLastName !== undefined) {
            formParams.append('patient_last_name', requestParameters.patientLastName as any);
        }

        if (requestParameters.patientEmail !== undefined) {
            formParams.append('patient_email', requestParameters.patientEmail as any);
        }

        if (requestParameters.patientPhone !== undefined) {
            formParams.append('patient_phone', requestParameters.patientPhone as any);
        }

        if (requestParameters.patientOhip !== undefined) {
            formParams.append('patient_ohip', requestParameters.patientOhip as any);
        }

        if (requestParameters.referralContext !== undefined) {
            formParams.append('referral_context', requestParameters.referralContext as any);
        }

        if (requestParameters.submitterEmail !== undefined) {
            formParams.append('submitter_email', requestParameters.submitterEmail as any);
        }

        if (requestParameters.attachmentsMetadata !== undefined) {
            formParams.append('attachments_metadata', requestParameters.attachmentsMetadata as any);
        }

        if (requestParameters.file0 !== undefined) {
            formParams.append('file_0', requestParameters.file0 as any);
        }

        if (requestParameters.file1 !== undefined) {
            formParams.append('file_1', requestParameters.file1 as any);
        }

        if (requestParameters.file2 !== undefined) {
            formParams.append('file_2', requestParameters.file2 as any);
        }

        if (requestParameters.file3 !== undefined) {
            formParams.append('file_3', requestParameters.file3 as any);
        }

        if (requestParameters.file4 !== undefined) {
            formParams.append('file_4', requestParameters.file4 as any);
        }

        const response = await this.request({
            path: `/referrals/submit`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalReferralResponseFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    submitExternalReferralRequestOptionsRaw(requestParameters: SubmitExternalReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.patientFirstName === null || requestParameters.patientFirstName === undefined) {
            throw new runtime.RequiredError('patient_first_name','Required parameter requestParameters.patientFirstName was null or undefined when calling submitExternalReferral.');
        }

        if (requestParameters.patientLastName === null || requestParameters.patientLastName === undefined) {
            throw new runtime.RequiredError('patient_last_name','Required parameter requestParameters.patientLastName was null or undefined when calling submitExternalReferral.');
        }

        if (requestParameters.patientEmail === null || requestParameters.patientEmail === undefined) {
            throw new runtime.RequiredError('patient_email','Required parameter requestParameters.patientEmail was null or undefined when calling submitExternalReferral.');
        }

        if (requestParameters.referralContext === null || requestParameters.referralContext === undefined) {
            throw new runtime.RequiredError('referral_context','Required parameter requestParameters.referralContext was null or undefined when calling submitExternalReferral.');
        }

        if (requestParameters.submitterEmail === null || requestParameters.submitterEmail === undefined) {
            throw new runtime.RequiredError('submitter_email','Required parameter requestParameters.submitterEmail was null or undefined when calling submitExternalReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.patientFirstName !== undefined) {
            formParams.append('patient_first_name', requestParameters.patientFirstName as any);
        }

        if (requestParameters.patientLastName !== undefined) {
            formParams.append('patient_last_name', requestParameters.patientLastName as any);
        }

        if (requestParameters.patientEmail !== undefined) {
            formParams.append('patient_email', requestParameters.patientEmail as any);
        }

        if (requestParameters.patientPhone !== undefined) {
            formParams.append('patient_phone', requestParameters.patientPhone as any);
        }

        if (requestParameters.patientOhip !== undefined) {
            formParams.append('patient_ohip', requestParameters.patientOhip as any);
        }

        if (requestParameters.referralContext !== undefined) {
            formParams.append('referral_context', requestParameters.referralContext as any);
        }

        if (requestParameters.submitterEmail !== undefined) {
            formParams.append('submitter_email', requestParameters.submitterEmail as any);
        }

        if (requestParameters.attachmentsMetadata !== undefined) {
            formParams.append('attachments_metadata', requestParameters.attachmentsMetadata as any);
        }

        if (requestParameters.file0 !== undefined) {
            formParams.append('file_0', requestParameters.file0 as any);
        }

        if (requestParameters.file1 !== undefined) {
            formParams.append('file_1', requestParameters.file1 as any);
        }

        if (requestParameters.file2 !== undefined) {
            formParams.append('file_2', requestParameters.file2 as any);
        }

        if (requestParameters.file3 !== undefined) {
            formParams.append('file_3', requestParameters.file3 as any);
        }

        if (requestParameters.file4 !== undefined) {
            formParams.append('file_4', requestParameters.file4 as any);
        }


        const responseConfig = {
            path: `/referrals/submit`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        };
        return responseConfig
    }

    /**
     * Submit an external referral with attachments (Public)
     */
    async submitExternalReferral(requestParameters: SubmitExternalReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalReferralResponse> {
        const response = await this.submitExternalReferralRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update an external referral (Roles: physician, admin)
     */
    async updateExternalReferralRaw(requestParameters: UpdateExternalReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ExternalReferral>> {
        if (requestParameters.referralId === null || requestParameters.referralId === undefined) {
            throw new runtime.RequiredError('referralId','Required parameter requestParameters.referralId was null or undefined when calling updateExternalReferral.');
        }

        if (requestParameters.externalReferral === null || requestParameters.externalReferral === undefined) {
            throw new runtime.RequiredError('ExternalReferral','Required parameter requestParameters.externalReferral was null or undefined when calling updateExternalReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/referrals/external/{referralId}`.replace(`{${"referralId"}}`, encodeURIComponent(String(requestParameters.referralId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExternalReferralToJSON(requestParameters.externalReferral),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ExternalReferralFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updateExternalReferralRequestOptionsRaw(requestParameters: UpdateExternalReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.referralId === null || requestParameters.referralId === undefined) {
            throw new runtime.RequiredError('referralId','Required parameter requestParameters.referralId was null or undefined when calling updateExternalReferral.');
        }

        if (requestParameters.externalReferral === null || requestParameters.externalReferral === undefined) {
            throw new runtime.RequiredError('ExternalReferral','Required parameter requestParameters.externalReferral was null or undefined when calling updateExternalReferral.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/referrals/external/{referralId}`.replace(`{${"referralId"}}`, encodeURIComponent(String(requestParameters.referralId))),
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ExternalReferralToJSON(requestParameters.externalReferral),
        };
        return responseConfig
    }

    /**
     * Update an external referral (Roles: physician, admin)
     */
    async updateExternalReferral(requestParameters: UpdateExternalReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ExternalReferral> {
        const response = await this.updateExternalReferralRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetExternalReferralsByStatusStatusEnum = {
    Pending: 'pending',
    Completed: 'completed',
    Rejected: 'rejected'
} as const;
export type GetExternalReferralsByStatusStatusEnum = typeof GetExternalReferralsByStatusStatusEnum[keyof typeof GetExternalReferralsByStatusStatusEnum];
